import React, { useState } from "react";
// Eski Table komponenti o'rniga ui-table; uning CSS'i tartib o'zgarmasligi uchun saqlangan
import '../../Components/Table/styles.css';
import "./styles.css";
import { useParams } from "react-router-dom";
import { BarChart3 } from "lucide-react";
import { Badge, Card, EmptyState, PageHeader, Pagination, SearchInput } from "../../Components/ui";
import "./CourseDetail.css";

const CourseDetail = () => {
    const { course } = useParams();
    const initialData = Array.from({ length: 105 }, (_, index) => ({
        id: index + 1,
        teacherName: "Xoldorova Nafisa",
        startDate: "12 Aug 2022 - 12:25 am",
        topic: "Audit va buxgalteriya",
        midtermResult: "92",
        finalResult: "92",
        purchasedCourses: "2",
        status: index % 2 === 0 ? "Completed" : "In-Progress",
    }));

    const [data, setData] = useState(initialData);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const rowsPerPage = 10;

    const totalPages = Math.ceil(data.length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;


    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);

        const filteredData = initialData.filter((row) =>
            row.teacherName.toLowerCase().includes(value)
        );
        setData(filteredData);
        setCurrentPage(1);
    };

    const columns = [
        { Header: "O'qituvchi", accessor: 'teacherName' },
        { Header: 'Boshlangan sana', accessor: 'startDate' },
        { Header: 'Mavzu', accessor: 'topic' },
        { Header: 'Oraliq natija', accessor: 'midtermResult' },
        { Header: 'Yakuniy natija', accessor: 'finalResult' },
        { Header: 'Sotib olingan kurslar', accessor: 'purchasedCourses' },
        { Header: 'Holat', accessor: 'status' },
    ];

    const currentRows = data.slice(startIndex, startIndex + rowsPerPage);

    return (
        <div className="ui-course-stats">
            <PageHeader title="Statistika" subtitle="Kurs bo'yicha o'quvchilar natijalari" />
            <Card padding="sm">
                <SearchInput
                    onChange={handleSearch}
                    placeholder="O'qituvchi ismi bo'yicha qidirish..."
                    wrapperClassName="ui-course-stats__search"
                />
            </Card>
            {currentRows.length === 0 ? (
                <Card padding="none">
                    <EmptyState icon={<BarChart3 />} title="Natija topilmadi" />
                </Card>
            ) : (
                <div className="ui-table-wrap">
                    <table className="ui-table">
                        <thead>
                            <tr>
                                {columns.map((column) => (
                                    <th
                                        key={column.accessor}
                                        className={['midtermResult', 'finalResult', 'purchasedCourses'].includes(column.accessor) ? 'ui-table-cell--numeric' : undefined}
                                    >
                                        {column.Header}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {currentRows.map((row) => (
                                <tr key={row.id}>
                                    <td className="ui-course-stats__name">{row.teacherName}</td>
                                    <td>{row.startDate}</td>
                                    <td>{row.topic}</td>
                                    <td className="ui-table-cell--numeric">{row.midtermResult}</td>
                                    <td className="ui-table-cell--numeric">{row.finalResult}</td>
                                    <td className="ui-table-cell--numeric">{row.purchasedCourses}</td>
                                    <td>
                                        <Badge variant={row.status === "Completed" ? "success" : "warning"} size="sm" dot>
                                            {row.status === "Completed" ? "Tugatgan" : "O'qimoqda"}
                                        </Badge>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <div className="ui-course-stats__footer">
                <span className="ui-course-stats__muted">
                    {data.length > 0
                        ? `${startIndex + 1}–${Math.min(startIndex + rowsPerPage, data.length)} / ${data.length}`
                        : '0 / 0'}
                </span>
                <Pagination page={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
            </div>
        </div>
    );
};

export default CourseDetail;